module.exports = __webpack_public_path__ + "static/media/project-libre.d7833503.jpg";